import api from '@pray/shared/utils/api';

export const getCommentReplies = async ({ artistId, commentId, cursor } = {}) => {
  if (!artistId) throw Error('Artist ID is required');
  if (!commentId) throw Error('Comment ID is required');

  const url = `/web/studio/artists/${artistId}/comments/${commentId}/replies/page`;
  const params = {};
  if (cursor) params.newest = cursor;

  const response = await api.executeGetRequest(url, params);
  return response.data;
};
